<template>
<div id="app">
  <div class="splash">
    <img src="@/assets/img/ba-logo.svg">
  </div>
  <header>
    <router-link :to="{ name: 'home' }" :class="{ info: $route.name == 'info'}" class="bunkall">
      <txt v-if="site" phrase="Bunkall"></txt>
      <txt v-if="site" phrase="Architects"></txt>
    </router-link>
    <navigation></navigation>
  </header>
  <router-view></router-view>
</div>
</template>

<script>
import {
  mapState
} from 'vuex'
const Navigation = () => import( /* webpackChunkName: "Navigation" */ '@/components/Navigation.vue')
const Txt = () => import( /* webpackChunkName: "Text" */ '@/components/Text.vue')

export default {
  name: 'App',
  metaInfo() {
    return {
      title: "Bunkall Architects",
      titleTemplate: "Bunkall Architects" + ' %s'
    }
  },
  components: {
    Navigation,
    Txt
  },
  computed: mapState(['site']),
  created() {
    this.$store.dispatch('loadSite');
  }
}
</script>

<style lang="scss">
@import 'node_modules/reset-css/sass/_reset';
@font-face {
    font-family: "SimilarMed";
    src: url("./assets/fonts/Similar-Medium.woff");
    font-style: normal;
    font-weight: 400;
    font-display: swap;
}
@font-face {
    font-family: "SimilarBold";
    src: url("./assets/fonts/Similar-Bold.woff");
    font-style: normal;
    font-weight: 400;
    font-display: swap;
}
* {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
:root {
    --fs: 1.3rem;
    --lh: calc(1.25 * 1.3rem);
    @media only screen and (min-width:1600px) {
        --fs: 1.5rem;
        --lh: calc(1.25 * 1.5rem);
    }
    @media only screen and (max-width:1024px) {
        --fs: 1.2rem;
        --lh: calc(1.25 * 1.2rem);
    }
    @media only screen and (max-width:768px) {
        --fs: 1.1rem;
        --lh: calc(1.25 * 1.1rem);
    }
    --color: rgb(0,0,0);
    --hover: rgb(150,150,150);
}

a,
a:active,
a:hover,
a:visited {
    color: var(--color);
    text-decoration: none;
    &:hover {
        color: var(--color);
    }
}

body,
html {
    font-size: var(--fs);
    line-height: var(--lh);
    width: 100%;
    height: 100%;
}

.splash {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 101;
    padding: var(--lh);
    animation: fadeOut 1s 1s forwards;
    display: flex;
    align-items: center;
}
@keyframes fadeOut {
    0% {
        opacity: 1;
        visibility: visible;
    }
    100% {
        opacity: 0;
        visibility: hidden;
        transform: translateY(5vw);
    }
}

#app {
    font-family: "SimilarBold", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    p {
        font-family: "SimilarMed", Helvetica, Arial, sans-serif;
        font-size: calc(0.8 * var(--fs));
        line-height: 1.25;
        margin-bottom: calc((0.8 * var(--fs)) * 1.2);
        &:last-of-type {
            margin-bottom: 0;
        }
    }
    .bold {
        font-size: var(--fs);
        line-height: var(--lh);
        font-family: "SimilarBold", Helvetica, Arial, sans-serif;
        p {
            font-size: var(--fs);
            line-height: var(--lh);
            font-family: "SimilarBold", Helvetica, Arial, sans-serif;
        }
    }
    .cap {
        text-transform: capitalize;
    }
    .tnum {
        font-feature-settings: "tnum";
    }
    header {
        padding: var(--lh);
        position: absolute;
        width: 100%;
        z-index: 99;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;
        .bunkall {
            div:first-of-type {
                margin-right: calc(0.2 * var(--lh));
            }
            @media only screen and (max-width: 1024px) {
                div {
                    display: block;
                }
            }
            &.info {
                transform: translateY(-200%);
            }
        }
        a {
            transition: transform 0.5s 0.5s;
        }

    }
    main {
        width: 100%;
        height: 100%;
        padding: calc(3 * var(--lh)) var(--lh) var(--lh);
        @media only screen and (max-width:1024px) {
            padding: calc(4 * var(--lh)) var(--lh) var(--lh);
        }
        .grid {
            display: grid;
            grid-gap: var(--lh);
            &.c-2 {
                grid-template-columns: repeat(2,1fr);
            }
            &.c-3 {
                grid-template-columns: repeat(3,1fr);
            }
        }
    }
    img {
        width: 100%;
    }
}
</style>
